export const componentIds = {
  ActionList: 'ActionList',
  ActionListItem: 'ActionListItem',
  ActionListItemBadge: 'ActionListItemBadge',
  ActionListItemBadgeGroup: 'ActionListItemBadgeGroup',
  ActionListItemAsset: 'ActionListItemAsset',
  ActionListItemIcon: 'ActionListItemIcon',
  ActionListItemAvatar: 'ActionListItemAvatar',
  ActionListItemText: 'ActionListItemText',
  ActionListSection: 'ActionListSection',
  ActionListSectionTitle: 'ActionListSectionTitle',
};
